<template lang="pug">
  #team-all-members
    .team-members-gallery(v-if="members")
      section.section
        .columns.is-multiline.is-centered
          template(v-for="teamMember in members")
            .column.is-3
              .box.has-shadow
                .columns.is-mobile.is-centered.is-multiline.has-text-centered
                  .column.is-full-tablet.is-half-mobile
                    EntityAvatar(:image="teamMember.avatar" is-rounded)
                  .column.is-full-tablet.is-half-mobile
                    .is-size-4(v-if="coreProgramMeta.showRealNames") {{ teamMember.name }}
                    div
                      WtRouterLink(
                        to="ProfilePage"
                        :params="{ username: teamMember.username }"
                        :text="'@'+teamMember.username"
                      )
      .columns.is-centered(v-if="pagination")
        .column.is-narrow
          BPagination(
            v-if="paginationKey"
            :key="paginationKey"
            :current="currentPageForComponent"
            :total="totalForComponent"
            :per-page="perPageForComponent"
            @change="onPageChange"
          )
</template>

<script>
import { mapGetters } from "vuex";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import EntityAvatar from "@/components/WtEntityAvatar/WtEntityAvatar";

export default {
  name: "TeamAllMembers",

  components: {
    EntityAvatar,
    WtRouterLink
  },

  props: {
    members: {
      type: Array,
      default: null
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),

    currentPageForComponent() {
      return this.pagination?.currentPage || 1;
    },

    totalForComponent() {
      return this.pagination?.total || 0;
    },

    perPageForComponent() {
      return this.pagination?.perPage || 15;
    },

    paginationKey() {
      return `pagination-${this.pagination?.currentPage}-${this.pagination?.total}`;
    }
  },

  methods: {
    onPageChange(page) {
      this.$emit("page-change", page);
    }
  }
};
</script>

<style lang="sass" scoped>
#team-all-members
  .team-members
    .media
      width: 0 // needed for IE11 fix
    .box.has-shadow
      box-shadow: 0 12px 24px 0 rgba(0,0,0,0.1)
    .wt-entity-avatar
      display: flex
      justify-content: center
  .box
    position: relative
</style>
